export default __webpack_public_path__ + "static/media/RacingNSW.2496548d.svg";